export const PYTH_REALTIME_CONNECTION_URL = "https://hermes.pyth.network";
export const PYTH_ETH_USD_FEED_ID = "ff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace";
export const PYTH_BTC_USD_FEED_ID = "e62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43";
export const MOON_OR_DOOM_DOCS_PAGE = "https://docs.yologames.io/games/multiplayer-games/moon-or-doom";
